import React, { useState } from "react";
import axios from "axios";
import logo from "../assets/logo.png";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card.jsx";
import { toast, Toaster } from "sonner";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Handle Login Submission
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("https://wavetechservices.in/api/admin/login", {
        email,
        password,
      });

      // Extract token from response
      const { token } = response.data;

      // Remove old token and store new one
      localStorage.removeItem("adminToken");
      localStorage.setItem("adminToken", token);

      console.log("response : " , response)
      toast.success("Login successful!");
      // Redirect to admin dashboard or other page
      window.location.href = "/admin";
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed. Try again.");
    }
  };

  return (
    <div className="" style={{ width: "98vw", height: "98vh" }}>
      <Toaster />
      <div className="flex justify-center items-center flex-col h-[90vh] relative">
        <div
          style={{
            backgroundPosition: "center",
            backgroundSize: "cover",
            width: "100%",
            height: "100%",
            filter: "blur(10px)",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
          }}
        ></div>

        <Card
          className="p-4 relative z-10 md:p-20 lg:p-4"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.3)",
            backdropFilter: "blur(10px)",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
            borderRadius: "10px",
          }}
        >
          <div className="flex justify-center items-center py-2">
            <img src={logo} alt="Logo" className="w-20" />
          </div>

          <form onSubmit={handleLogin}>
            <div className="relative z-0 w-72 mb-5 group">
              <input
                id="email"
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label
                htmlFor="email"
                className="absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Email address
              </label>
            </div>

            <div className="relative z-0 w-72 mb-5 group">
              <input
                id="password"
                type="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                placeholder=" "
                required
              />
              <label
                htmlFor="password"
                className="absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Password
              </label>
            </div>

            <div className="text-center">
              <Button type="submit" className="h-8 gradient">
                SIGN IN
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
